import { render, staticRenderFns } from "./LetsMakeASelfieTemplate.vue?vue&type=template&id=70b1f937&scoped=true"
import script from "./LetsMakeASelfieTemplate.vue?vue&type=script&lang=js"
export * from "./LetsMakeASelfieTemplate.vue?vue&type=script&lang=js"
import style0 from "./LetsMakeASelfieTemplate.vue?vue&type=style&index=0&id=70b1f937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1f937",
  null
  
)

export default component.exports